import RegistrarDashboard from '../registrarDashboard';

export const RegistrarPanel = () => {
  return (
    <div>
      <RegistrarDashboard />
    </div>
  );
};
